import { render, staticRenderFns } from "./CuratedRtqInstumentsTable.vue?vue&type=template&id=3cb35128&scoped=true"
import script from "./CuratedRtqInstumentsTable.vue?vue&type=script&lang=ts"
export * from "./CuratedRtqInstumentsTable.vue?vue&type=script&lang=ts"
import style0 from "./CuratedRtqInstumentsTable.vue?vue&type=style&index=0&id=3cb35128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb35128",
  null
  
)

export default component.exports